/**
 * Camada abstrata de persistência — a lógica do jogo NÃO depende de localStorage
 * diretamente. Futuramente troque por Cloud/Database/Steam/Mobile implementando
 * esta interface.
 */
export interface SaveStorage {
  load(key: string): string | null;
  save(key: string, value: string): void;
  remove(key: string): void;
}

export class LocalStorageBackend implements SaveStorage {
  load(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  save(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      /* quota/modo privado: ignora silenciosamente */
    }
  }

  remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      /* ignora */
    }
  }
}
